const theme = {
  mainLightest: '#DCD7FF',
  mainLight: '#A89AFF',
  main: '#6F5CE6',
  mainDarker: '#5042A5',
  mainDarkest: '#1E1652',
  complementaryAqua: '#121418',
  complementaryLemon: '#242734',
  panel: '#2C3041',
  complementaryRoyalPurple: '#6F5CE6',
  success: '#33C2B0',
  error: '#DE0000',
  attempt: '#FFCC33',
  textCharcoal: '#121418',
  textDarkGrey: '#5E5F65',
  textGrey: '#A5A1B7',
  textWhite: '#FFF',
  backgroundAvobe: '#242734',
  backgroundSurface: '#191B23',
  backgroundBelow: '#12141A'
}

export default theme
